import AvatarGroup from './AvatarGroup';

export default AvatarGroup;
